const adminReseller = {
  resellerProgram: 'Programa de revendedores',
  customersComeFrom: 'Los clientes provienen de:',
  suppliers: 'Proveedores:',
  installsSoldMonthly: 'Instalaciones vendidas mensualmente:',
  channels: 'Canales:',
  services: 'Servicios:',
};

export default adminReseller;
